import React, { useState, useEffect, useRef } from 'react'
import { Loading } from '../Loading'
import { isSDKLoaded, initialiseSDK, getCreditCardForm, getPaymentToken } from 'services/funpoint'
import { Cookies } from 'utils'


const FunPointForm = ({ 
    display, 
    card_bound,
    form_token,
    three_d_url,
    onFunPointCardAddRequest,
    onFunPointCardRemoveRequest,
}) => {
    const [sdkLoaded, setSdkLoaded] = useState(isSDKLoaded());
    const [initialised, setInitialised] = useState(false);
    const [formLoaded, setFormLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [shouldLoadForm, setShouldLoadForm] = useState(true);
    const [error, setError] = useState(null);
    const formRef = useRef(null);
    const getForm = (token) => {
        setLoading(true);
        getCreditCardForm(token, (err) => {
            if (err) { 
                setError('FORM_ERROR'); 
            } else {
                setFormLoaded(true);
                setError(null);
            }

            setLoading(false);
        });
    };
    const checkBindingCard = () => {
        if (typeof window.BindingCard !== 'undefined') {
            setLoading(true);
            getPaymentToken((paymentInfo, err) => {
                if (err) {
                    setError('CARD_ERROR');
                    
                    console.log('Payment token error:', err);

                    return;
                } else {
                    /**
                     * BindCardPayToken: "b6aa2744b8cb405d8a2228f7e14d9ab3"
                     * CVV: "222"
                     * MerchantID: "1000031"
                     * MerchantMemberID: "U42241"
                     * PayToken: null
                     * PaymentType: "CreditCard"
                     */
                    onFunPointCardAddRequest({ token: paymentInfo.BindCardPayToken });
                }
            });
        } else {
            // Check again after a short delay
            setTimeout(checkBindingCard, 100);
        }
    };
    const removeCard = () => {
        setLoading(true);
        onFunPointCardRemoveRequest({ token: card_bound.BindCardID });
    };

    useEffect(() => {
        // import after container rendered
        const script = document.createElement('script');
        
        // development
        script.src = 'https://ecpg-stage.funpoint.com.tw/Scripts/sdk-1.0.0.src.js?t=20210121100116';
        
        // production
        // script.src = 'https://ecpg.funpoint.com.tw/Scripts/sdk-1.0.0.src.js?t=20210121100116';

        document.getElementsByTagName('head')[0].appendChild(script);
    }, []);

    useEffect(() => {
        // check if card(s) bound
        setLoading(false);
        setShouldLoadForm(card_bound === null);
    }, [ card_bound ]);
    
    useEffect(() => {
        if (!sdkLoaded) { 
            setInterval(() => setSdkLoaded(isSDKLoaded()), 500); 
            
            return;
        }

        if (initialised || display !== 'block') { return; }

        setLoading(true);
        initialiseSDK((err) => {
            if (err) { 
                setError('INIT_ERROR'); 
            } else {
                setInitialised(true);
                setError(null);
            }

            setLoading(false);
        });
    }, [ sdkLoaded, initialised, display ]);
    
    useEffect(() => {
        if (shouldLoadForm) {
            if (initialised && form_token) { getForm(form_token); }
        } else {
            setLoading(false);
        }
    }, [ initialised, form_token, shouldLoadForm ]);

    useEffect(() => {
        if (three_d_url) {
            Cookies.remove('redirect_path', { path: '/' });
            window.location.replace(three_d_url); 
        }
    }, [ three_d_url ]);
    
    return (
        <div className={`funpoint-form d-${display}`}>
            {loading && <Loading />}

            {error 
                ? (
                    <div className='feedback margin-top-10vh text-center'>
                        <div className='feedback-title'>
                            <i className='txt-orange txt-5em elegant elegant-eleganticons-81'/>

                            <h1>信用卡付款流程出現錯誤，請重新整理後再操作一次</h1>
                        </div>
                    </div>
                )
                : (
                    <>
                        <div id='funpointPayment' ref={formRef}/>

                        {card_bound && (
                            <h1 className='bound-card margin-top-50 text-center'>
                                {card_bound.Card6No}******{card_bound.Card4No}
                            </h1>
                        )}

                        <div className='btn-container'>
                            {card_bound && (
                                <button 
                                    type='button' 
                                    className='cancel ua-btn outline'
                                    onClick={removeCard}
                                >
                                    換張卡
                                </button>
                            )}

                            <button 
                                type='button' 
                                className={`ua-btn default d-${formLoaded ? 'block' : 'none'}`}
                                disabled={!formLoaded}
                                onClick={checkBindingCard}
                            >
                                {card_bound ? '使用' : '綁定'}
                            </button>
                        </div>
                    </>
                )
            }
        </div>
    );
};


export { FunPointForm }